import React, {useEffect, useState} from 'react';
import logo from '../images/logo.svg';

function LoadingScreen() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setVisible(true);
    }, 500);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div
      // e2e/smoke.spec.ts waits for this to unmount before checking the routed page.
      data-loading-screen
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        color: 'white',
        backgroundColor: 'black',
        flexDirection: 'column',
      }}
    >
      {visible ? <img src={logo} alt="RISE" style={{width: 66}} /> : null}
    </div>
  );
}

export default LoadingScreen;
